<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-primary py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <notifications></notifications>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--9 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <form class="needs-validation" @submit.prevent="handleSubmit()">
                <base-password-input
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-lock-circle-open"
                  placeholder="Nueva contraseña"
                  name="Password"
                  v-model="form.data.password"
                >
                </base-password-input>
                <validation-error :errors="apiValidationErrors.password" />

                <base-password-input
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-lock-circle-open"
                  placeholder="Repita nueva contraseña"
                  name="Confirm Password"
                  v-model="form.data.passwordConfirmation"
                >
                </base-password-input>

                <div class="text-center">
                  <base-button type="primary" native-type="submit" class="my-4"
                    >Crear contraseña</base-button
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
export default {
  layout: "AuthLayout",
  mixins: [formMixin],
  components: { ValidationError },
  data() {
    return {
      form: {
        data: {
          type: "password-reset",
          password: "",
          passwordConfirmation: "",
          code: "",
          attributes: {
            email: "",
          },
        },
      },
    };
  },
  mounted() {
    this.form.data.code = this.$route.query.code;
  },
  beforeDestroy() {
    this.$router.replace({ query: null });
  },
  methods: {
    async handleSubmit() {
      var obj = {
        password: this.form.data.password,
        passwordConfirmation: this.form.data.passwordConfirmation,
        code: this.form.data.code,
      };
      console.log(obj);
      try {
        await this.$store.dispatch("reset/createNewPassword", obj);
      } catch (error) {
        await this.$notify({
          type: "danger",
          message: "Datos no válidos.",
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
  },
};
</script>
